export const stamp = () => new Date().toISOString().slice(0, 10);
export const safe = s => String(s || "All").replace(/[^A-Za-z0-9_-]+/g, "-").replace(/-+/g, "-").replace(/^-|-$/g, "") || "All";

function toCsv(head, rows) {
  const q = v => { if (v === null || v === undefined) return ""; const s = String(v); return /[",\n\r]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s; };
  return "\ufeff" + [head, ...rows].map(r => r.map(q).join(",")).join("\r\n");
}

function download(blob, filename) {
  const url = URL.createObjectURL(blob), a = document.createElement("a");
  a.href = url; a.download = filename; a.style.display = "none";
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// spec: {name, sheet, head, rows, about:[[k,v],...]}
export async function exportTable(spec, fmt, toast) {
  try {
    const filename = `${spec.name}.${fmt}`;
    let blob;
    if (fmt === "csv") blob = new Blob([toCsv(spec.head, spec.rows)], { type: "text/csv;charset=utf-8" });
    else {
      const X = await import("xlsx");
      const wb = X.utils.book_new();
      const ws = X.utils.aoa_to_sheet([spec.head, ...spec.rows]);
      ws["!cols"] = spec.head.map((h, i) => ({ wch: Math.min(48, Math.max(String(h).length, ...spec.rows.slice(0, 400).map(r => String(r[i] ?? "").length)) + 2) }));
      X.utils.book_append_sheet(wb, ws, spec.sheet.slice(0, 31));
      if (spec.about) X.utils.book_append_sheet(wb, X.utils.aoa_to_sheet([["Field", "Value"], ...spec.about]), "About");
      blob = new Blob([X.write(wb, { type: "array", bookType: "xlsx" })], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    }
    download(blob, filename);
    toast(`Saved ${filename}`);
  } catch (e) {
    toast(`Export failed: ${(e && e.message) || "unknown error"}`);
  }
}
